import { getDayInResourceTz } from './datetime';

// Month as a Monday-first grid: leading nulls, then 1..daysInMonth.
export const monthGrid = (year, month) => {
  const first = new Date(Date.UTC(year, month - 1, 1)).getUTCDay();
  const lead = (first + 6) % 7;
  const days = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return [...Array(lead).fill(null), ...Array.from({ length: days }, (_, i) => i + 1)];
};

// A session is still open for submission until its gate closure passes.
// Shared by summarizeDays and SubmissionHeatmap so the calendar and the
// heatmap can never disagree about which sessions count as open vs. missed.
export const isSessionOpen = (session, nowMs = Date.now()) => {
  if (!session?.gate_closure || session.submitted) return false;
  const gateMs = new Date(session.gate_closure).getTime();
  return !Number.isNaN(gateMs) && gateMs > nowMs;
};

// Per resource-local day: how many sessions, submitted, still open, missed.
// Keys off gate_closure (resource timezone), matching SubmissionHeatmap's
// day attribution so the calendar and the heatmap never disagree about
// which day a session belongs to.
export const summarizeDays = (sessions, nowMs = Date.now()) => {
  const byDay = {};
  (sessions || []).forEach((s) => {
    if (!s.gate_closure) return;
    const day = getDayInResourceTz(s.gate_closure);
    if (day == null) return;
    const entry = byDay[day] || (byDay[day] = { total: 0, submitted: 0, open: 0, missed: 0, sessions: [] });
    const open = isSessionOpen(s, nowMs);
    entry.total += 1;
    if (s.submitted) entry.submitted += 1;
    else if (open) entry.open += 1;
    else entry.missed += 1;
    entry.sessions.push({ ...s, open });
  });
  return byDay;
};

export const dayState = (summary) => {
  if (!summary || summary.total === 0) return 'none';
  if (summary.missed === 0) return summary.open === 0 ? 'complete' : 'open';
  return summary.submitted === 0 ? 'missed' : 'partial';
};
